<template lang="pug">
  .component-selectize-vehicle
      selectize( v-if="options", v-model="selectedValue" ref="selectize", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved", placeholder="Vehicle")
</template>

<script>
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import BaseSelectize from './BaseSelectize'
  import Selectize from '../../../Selectize'

  export default {
    name: 'SelectizeVehicle',
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'brand',
          'model',
          'plate',
          'parking_lot_id',
          'parking_lot_name',
          'parking_slot'
        ],
        rerender : 0,
      }
    },
    created() {
      KeplerBackofficeSdk.selects.vehicles(this.disabledSlot, this.archived, (data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        const parkingLotName = item.parking_lot_name !== null ? item.parking_lot_name : ''
        const parkingLotId = item.parking_lot_id !== null ? `<i class="fa fa-car"></i>PS${item.parking_lot_id}` : ''

        const vehicleSlotId = item.vehicle_slot_id !== null ? `VS${item.vehicle_slot_id}` : ''
        return `<div><div><small>${parkingLotId} ${parkingLotName}</small></div><div>V${item.id} ${item.brand} ${item.model}</div> <div><small>${vehicleSlotId} ${item.plate}</small></div></div>`
      },
      renderTemplate(item, escape) {
        return `<div>${item.brand} ${item.model}<br><small>${item.plate}</small></div>`
      },
      optionsLoader() {

      },
      clearSelected() {
        this.$refs.selectize.clearSelected()
      }
    },
    props: ['selectedValue', 'disabledSlot', 'archived']

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeVehicle.vue?250d3610